
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class RealLazyImg extends Vue {
  @Prop({ default: '' }) url!: string
  @Prop({ default: '' }) originUrl!: string
  @Prop({ required: true, default: () => ({ width: 0, height: 0 }) }) imageSize!: { width: number; height: number }
  @Prop({ default: 595 }) distance: number
  @Prop({ default: 4 }) count: number
  @Prop() order!: number

  ob: IntersectionObserver | null = null

  isError: boolean = false

  @Ref()
  realLazyImg!: HTMLDivElement

  get bottomDistance(): number {
    return this.distance * this.count
  }

  @Emit('load-url-fail')
  onLoadError() {
    // 加载失败事件只处理一次
    if (this.isError) return

    this.isError = true

    return {
      url: this.originUrl,
      order: this.order
    }
  }

  onLoadImg() {}

  created(): void {}

  mounted(): void {
    this.ob = new IntersectionObserver(
      entity => {
        if (entity[0].isIntersecting) {
          this.$emit('pre-load', {
            url: this.originUrl,
            order: this.order
          })
        }
      },
      {
        rootMargin: `0px 0px ${this.bottomDistance}px 0px`,
        threshold: [0, 1]
      }
    )

    this.ob.observe(this.realLazyImg)
  }

  updated(): void {}

  destroyed(): void {
    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
